export default class DhipayaInsurance {
    static CODE = 'DHPY'
    static RATES = []

    setRate( rates ){
        this.RATES = rates
        return this.RATES
    }

    getPrice( price ){
        price = +price
        let rate =  this.RATES.find( rate => {
            return price >= rate.min && price <= rate.max
        })
        return this.convertResponse( rate )
    }

    convertResponse( rate ){
        let res = {
            status: false,
            type: null,
            msg: "",
            data: {
                min: 0,
                max: 0,
                cost: 0,
                rate: 0,
                price: 0,
            }
        }
        if( rate ){
            res.status = true
            res.data.min = rate.min
            res.data.max = rate.max
            res.data.cost = rate.cost
            res.data.rate = rate.rate
            res.data.price = rate.price
        }else{
            res.type = 'OVER_DECLARED_VALUE'
            res.msg = 'มูลค่าสินค้า ไม่รองรับประกัน'
        }
        return res
    }
}